
// CONSTANTS
// ---- brevetScreen
export const kBrevetLevelAsStatement = "Une erreur est survenue pendant le chargement du contenu"
export const kBrevetLevelAsReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kBrevetLevelAsSentry = "Error in fetching brevet LevelAs"

// ---- flashScreen
export const kFlashSubthemesStatement = "Une erreur est survenue pendant le chargement des thèmes"
export const kFlashSubthemesReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kFlashSubthemesSentry = "Error in fetching Subthemes"

export const kFlashQuestionsStatement = "Une erreur est survenue pendant le chargement des questions du Flash"
export const kFlashQuestionsReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kFlashQuestionsSentry = "Error in fetching Questions"

// ---- exerciserScreen
export const kExerciserFetchStatement = "Une erreur est survenue dans le chargement des questions de l'exercice"
export const kExerciserFetchReassurance = "Nous sommes sincèrement désolés et faisons notre possible pour résoudre le problème au plus vite"
export const kExerciserResultsSentry = "Error in fetching exerciser"

export const kExerciserResultsStatement = "Une erreur est survenue dans l'affichage des résultats"
export const kExerciserResultsReassurance = "Nous sommes sincèrement désolés et faisons notre possible pour résoudre le problème au plus vite"
export const kExerciserFetchSentry = "Error in exerciser results"

export const kExerciserCorrectionStatement = "Une erreur est survenue dans l'affichage de la correction"
export const kExerciserCorrectionReassurance = "Nous sommes sincèrement désolés et faisons notre possible pour résoudre le problème"
export const kExerciserCorrectionSentry = "Error in exerciser correction"

// ---- levelAScreen
export const kLevelAStatement = "Une erreur est survenue dans le chargement du savoir-faire"
export const kLevelAReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kLevelASentry = "Error in fetching LevelA"

// ---- System
export const kSystemGradesStatement = "Une erreur est survenue pendant le chargement des niveaux"
export const kSystemGradesReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kSystemGradesSentry = "Error in fetching Grades in "
// ---- Api
// ---- ---- Unknown
export const kApiUnknownStatement = "Une erreur serveur est survenue"
export const kApiUnknownReassurance = "Nous faisons notre possible pour résoudre le problème au plus vite"
export const kApiUnknownSentry = "Error, unknown from api in "
// ---- ---- Empty response
export const kEmptyResponseStatement = "Aucune donnée trouvée"
export const kEmptyResponseReassurance = "Nous allons faire au plus vite pour résoudre le problème"
export const kEmptyResponseSentry = "Error, empty response from api in "

// PROPERTIES
// ---- brevetScreen
export const kBrevetLevelAsError = {
    statement: kBrevetLevelAsStatement,
    reassurance : kBrevetLevelAsReassurance,
    sentry: kBrevetLevelAsSentry,
}

// ---- exerciserScreen
export const kExerciserFetchError = {
    statement: kExerciserFetchStatement,
    reassurance : kExerciserFetchReassurance,
    sentry: kExerciserFetchSentry,
}

export const kExerciserResultsError = {
    statement: kExerciserResultsStatement,
    reassurance : kExerciserResultsReassurance,
    sentry: kExerciserResultsSentry,
}

export const kExerciserCorrectionError = {
    statement: kExerciserCorrectionStatement,
    reassurance : kExerciserCorrectionReassurance,
    sentry: kExerciserCorrectionSentry,
}

// ---- flashScreen
export const kFlashSubthemesError = {
    statement: kFlashSubthemesStatement,
    reassurance : kFlashSubthemesReassurance,
    sentry: kFlashSubthemesSentry,
}
export const kFlashQuestionsError = {
    statement: kFlashQuestionsStatement,
    reassurance : kFlashQuestionsReassurance,
    sentry: kFlashQuestionsSentry,
}

// ---- levelAScreen
export const kLevelAError = {
    statement: kLevelAStatement,
    reassurance : kLevelAReassurance,
    sentry: kLevelASentry,
}

// ---- System
export const kSystemGradesError = {
    statement: kSystemGradesStatement,
    reassurance : kSystemGradesReassurance,
    sentry: kSystemGradesSentry,
}

// ---- Api
// ---- ---- Unknown
export const kApiUnknownError = {
    statement: kApiUnknownStatement,
    reassurance: kApiUnknownReassurance,
    sentry: kApiUnknownSentry
}
// ---- ---- Empty response
export const kEmptyResponseError = {
    statement: kEmptyResponseStatement,
    reassurance: kEmptyResponseReassurance,
    sentry: kEmptyResponseSentry
}